// Intentionally rendered as a no-op so the floating "Get a Quote" button
// no longer appears anywhere on the site. Kept as a module so that existing
// imports in App.js continue to work without changes.
const FloatingBookCta = () => null;
export default FloatingBookCta;
